import { useMemo, useSyncExternalStore } from "react";
import { LifecycleOperations } from "./operations.ts";

export function useLifecycleOperations(account: string) {
  const operations = useMemo(() => new LifecycleOperations(), [account]);
  const state = useSyncExternalStore(
    operations.subscribe,
    operations.getSnapshot
  );
  return { operations, state };
}
